export default __webpack_public_path__ + "static/media/sky-chest-open-tab.d7cc4637.png";